import React from "react";

import { FormattedMessage } from "gatsby-plugin-react-intl";
import parse from "html-react-parser";
import sanitizeHtml from "sanitize-html";

import AdaptiveIcon from "../components/adaptiveIcon/adaptiveIcon";
import LinkButton from "../components/button/linkButton";
import { ReactComponent as IconPasswordReset18 } from "../icons/icon/18/a-icon-passwordreset-18.svg";
import { ReactComponent as IconFurther24 } from "../icons/icon/24/a-icon-further-24.svg";
import { ReactComponent as IconPasswordReset24 } from "../icons/icon/24/a-icon-passwordreset-24.svg";

const getAccountSignUpErrorCode = (error, intl, errorCode = null, modalLeaveUrl = null) => {
  let errorMessage = (error.status >= 400)
    ? intl.formatMessage({ id: "error.signup_code_error" }, { error: error.message, status: error.status })
    : intl.formatMessage({ id: "io.error.default_title" });
  let action = null;
  const signUpErrorCodes = ["001", "002", "003", "004", "005"];

  if (error.status === 422 && signUpErrorCodes.indexOf(errorCode) !== -1) {
    errorMessage = parse(sanitizeHtml(
      intl.formatMessage({ id: `error_signup_${errorCode}` }),
      { allowedTags: ["a"] },
    ));

    if (errorCode === "003" || errorCode === "005") {
      action = (
        <LinkButton href={process.env.GATSBY_SSP_FORGOT_PASSWORD_LINK}>
          <AdaptiveIcon lg={<IconPasswordReset24 />} sm={<IconPasswordReset18 />} />
          <FormattedMessage id="signup.reset_password" />
        </LinkButton>
      );
    } else if (modalLeaveUrl) {
      action = (
        <LinkButton href={modalLeaveUrl}>
          <FormattedMessage id="account.complete_registration" /><IconFurther24 />
        </LinkButton>
      );
    }
  }

  return { action, errorMessage };
};

export default getAccountSignUpErrorCode;
